function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clsss-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Asset 1");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "clsss-1",
  d: "M104,16.61v99.15H13.79a8.7893,8.7893,0,0,1-6.21-15.01,8.7046,8.7046,0,0,1,6.21-2.58H97V0H13.79A13.8106,13.8106,0,0,0,0,13.79v93.18a13.8042,13.8042,0,0,0,13.79,13.79H109V16.61ZM21.68,24.87H33.86L49.28,44.63,64.72,24.87H76.91V75.1H63.29V46.76L49.28,62.91,35.3,46.76V75.1H21.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsss-1",
  d: "M140.28,47.09,130.59,59.3,121,47.09h-5.41V75.1h6.02V56.51l8.98,11.38,9.01-11.46V75.1h5.99V47.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsss-1",
  d: "M152.78,47.09V75.1h6.02V47.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsss-1",
  d: "M173.56,47.09V66.1a4.1334,4.1334,0,0,1-1.12,3.08,4.205,4.205,0,0,1-3.08,1.12,4.1594,4.1594,0,0,1-1.85-.44,4.688,4.688,0,0,1-1.17-.73c-.17-.19-.3-.33-.38-.44l-3.59,3.62.8.84a8.4281,8.4281,0,0,0,2.62,1.7,9.3642,9.3642,0,0,0,3.98.86,9.6649,9.6649,0,0,0,7.1-2.67,9.3342,9.3342,0,0,0,2.71-6.94V47.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsss-1",
  d: "M205.55,47.09V64.9L191.76,47.09h-5.21V75.1h6.02V57.31L206.35,75.1h5.2V47.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsss-1",
  d: "M215.94,47.09V52.5h8.01V75.1h6V52.5h7.99V47.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsss-1",
  d: "M254.13,47.09h-6.39L236.73,75.1h6.4l2.4-6.6h10.8l2.41,6.6h6.4Zm-6.6,16.21,3.41-9.2,3.4,9.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsss-1",
  d: "M282.74,58.69l10.39-11.6h-6.99l-11,12.21V47.09h-6.01V75.1h6.01V67.09l3.6-3.98,8.2,11.99h6.99Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsss-1",
  d: "M303.54,69.71V63.5h11.39V58.11H303.54V52.5h14.59V47.09h-20.6V75.1h21.01V69.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "clsss-1",
  d: "M343.11,47.09V64.9L329.32,47.09h-5.21V75.1h6.01V57.31L343.91,75.1h5.2V47.09Z"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 349.1101 120.76",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.23d5c1e5.svg";
export { ForwardRef as ReactComponent };